import { Component, EventEmitter, Output } from '@angular/core';

import { AppConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { NativeAppService } from '@frontend/vanilla/core';

@Component({
    selector: 'ms-wallet-help',
    templateUrl: './wallet-help.component.html',
    standalone: false,
})
export class WalletHelpComponent {
    @Output() close = new EventEmitter<void>();

    constructor(
        public siteCore: Sitecore,
        public nativeAppService: NativeAppService,
        public appConfig: AppConfig,
    ) {}

    closeClick(): void {
        this.close.emit();
    }

    get walletHelpUrl(): string {
        return (this.siteCore.betslip.links.help.walletselectorhelp && this.siteCore.betslip.links.help.walletselectorhelp.url) || '';
    }
}
